//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  methods: {
    performAction: function performAction(event) {
      // this.$el.dispatchEvent(new Event("drawers/clickButton", { bubbles: true }))
      this.$dispatchEvent("drawers/clickButton", {});
      this.$onClick(event);
    }
  }
};